import type { ActivityType } from '../types';
import type { IconName } from '@/shared/ui/atoms/Icon';

export type ActivityTone = 'ink' | 'primary' | 'success' | 'warn';

/** The icon and tone of each kind of activity (the project feed and the notifications use the same). */
export const ACTIVITY_ICON: Record<ActivityType, { icon: IconName; tone: ActivityTone }> = {
  TASK_CREATED: { icon: 'plus', tone: 'ink' },
  TASK_MOVED: { icon: 'tasks', tone: 'primary' },
  TASK_COMPLETED: { icon: 'done', tone: 'success' },
  MILESTONE_COMPLETED: { icon: 'flag', tone: 'success' },
  TIME_LOGGED: { icon: 'clock', tone: 'primary' },
  COMMENT: { icon: 'comment', tone: 'primary' },
  ATTACHMENT: { icon: 'attach', tone: 'ink' },
  RISK: { icon: 'warning', tone: 'warn' },
  MEMBER_JOINED: { icon: 'userPlus', tone: 'ink' },
  PROJECT_CREATED: { icon: 'projects', tone: 'ink' }
};
